import React, {useEffect, useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { log } from '../../utils/jsUtils';

import Grid from '@mui/material/Grid';
import Fab from '@mui/material/Fab';
import Button from '@mui/material/Button';

import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';

import { useTheme } from '@mui/material/styles';
import { createClasses } from '../../utils/stylesUtils';
import paginateFooterStyles from './Styles/PaginateFooter.Style';
import commonListTableStyles from '../Styles/CommonListTable.Style';
import memberContentStyles from '../Feed/Styles/MemberContent.Style';
import { selectFilterSelections } from '../../reduxStore/modules/feed/selectors';
import { setFilterPageNumber } from '../../reduxStore/modules/feed/actions';

type Props = {
  // Note: removed classes prop as it's now generated internally
};

const PaginateFooter = (props: Props) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  
  // Create combined styles following the existing pattern
  const classes = createClasses({
    ...paginateFooterStyles,
    ...commonListTableStyles,
    ...memberContentStyles
  }, theme);
  
  // Get data from Redux store
  const filterSelections = useSelector(selectFilterSelections) || {};
  const totalRequests = useSelector(state => state.feed?.totalRequests) || 0;
  
  // Default values to prevent undefined errors
  const pageNb = filterSelections.pageNb || 0;
  const itemsPerPage = filterSelections.itemsPerPage || 50; // Keep consistent with backend expectation

  // log('filterSelections: ', filterSelections);
  // log('totalRequests: ', totalRequests);
  const changePage = (newPageNb: number) => {
    dispatch(setFilterPageNumber(newPageNb));
  };

  return (
  <Grid
    sx={classes.paginateFooter}
    container
  >
    <Grid
      sx={classes.pagePrev}
      item
    >
      {
        pageNb > 0
        ? <Fab
            aria-label="Previous"
            sx={classes.fab}
            onClick={() => changePage(pageNb - 1)}
            size="small"
          >
            <ArrowLeftIcon />
          </Fab>
        : null
      }
    </Grid>
    <Grid
      sx={classes.pageNumber}
      item
    >
      <Button
        sx={classes.button}
        disabled
      >{`Page ${pageNb + 1} / ${totalRequests > 0 ? Math.ceil(totalRequests / itemsPerPage) : 0}`}</Button>
    </Grid>
    <Grid
      sx={classes.pageNext}
      item
    >
      {
        pageNb + 1 < Math.ceil(totalRequests / itemsPerPage)
        ? <Fab
            aria-label="Next"
            sx={classes.fab}
            onClick={() => changePage(pageNb + 1)}
            size="small"
          >
            <ArrowRightIcon />
          </Fab>
        : null
      }
    </Grid>
  </Grid>
  );
};

export default PaginateFooter;

